import React, { FC, useState } from 'react';
import { Box, Typography, LinearProgress, Pagination, IconButton } from '@mui/material';
import { useGetOrdersByCustomerIdQuery } from '@services';
import { Customer } from '@models';
import OrderListItem from './OrderListItem/OrderListItem';
import { SubTitle } from '@components';
import CachedIcon from '@mui/icons-material/Cached';

type Props = {
  selectedCustomer: Customer;
};

export const OrderHistory: FC<Props> = ({ selectedCustomer }) => {
  const { data, isLoading, refetch } = useGetOrdersByCustomerIdQuery({ customerId: selectedCustomer.id });

  const [currentPage, setCurrentPage] = useState(1);

  // get current orders on history page
  const ordersPerPage = 20;
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstPost = indexOfLastOrder - ordersPerPage;
  const currentOrders = data?.slice(indexOfFirstPost, indexOfLastOrder);

  const totalPages: number = Math.ceil((data?.length !== undefined ? data.length : 1) / ordersPerPage);

  const handleOrderHistoryPageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  return (
    <>
      <SubTitle
        title="Order History"
        adornment={
          <IconButton
            onClick={() => {
              console.log('clicked');
              refetch();
            }}
            size="small"
            sx={{ ml: 2 }}
            data-testid="subtitle-icon-button"
          >
            <CachedIcon />
          </IconButton>
        }
      />
      <Box data-testid="customer-orders">
        {isLoading && <LinearProgress sx={{ my: 1 }} />}
        {currentOrders ? (
          currentOrders?.map((order) => <OrderListItem order={order} key={`${order.id}-${new Date().getTime()}`} />)
        ) : (
          <Typography padding={2} paddingLeft={1}>
            This customer has not made any orders.
          </Typography>
        )}
        <Box display="flex" justifyContent="flex-end" paddingTop={2}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handleOrderHistoryPageChange}
            color="primary"
            variant="outlined"
            shape="rounded"
          />
        </Box>
      </Box>
    </>
  );
};
